import styled from 'styled-components';

/**
 * A standard wrap around a complete page that will handle the correct padding from the sides
 */
export const PageContainer = styled.div`
    margin-inline: auto;
    padding-inline: var(--cds-size-page-gutter);
    width: 100%;
    max-width: var(--size-maxPageWidth);
`;
